import { client } from '@/shared/lib/client';
import { isInternalDomain } from '@/utils/const';

export interface FeedbackSubmitParams {
  feedbackType: 'bug_report' | 'feature_request';
  description: string;
  fileUrls?: string[];
  sessionId?: string;
  chatId?: string;
  requestId?: string;
  appLogUrl?: string;
  chatLogUrl?: string;
  systemInfo?: string;
  extensionInfo?: string;
  traceId?: string;
  /** 提交类型：user-用户手动提交反馈，auto-自动上报 */
  submitType?: 'user' | 'auto';
}

export interface FeedbackSubmitResponse {
  status: number;
  data?: {
    feedbackId: number;
    submitTime: number;
  };
  message?: string;
}

/**
 * 提交用户反馈
 */
export const submitFeedback = async (
  params: FeedbackSubmitParams,
): Promise<FeedbackSubmitResponse> => {
  // 根据域名选择提交接口
  const submitUrl = isInternalDomain()
    ? '/eapi/kwaipilot/feedback/submit'
    : '/api/proxy/eapi/kwaipilot/feedback/submit';

  const response = (await client({
    url: submitUrl,
    method: 'POST',
    data: params,
  })) as FeedbackSubmitResponse;

  return response;
};
